import cn from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import barcode_image from '../../../../assets/media/barcode-scan.png';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../components/Basic/Buttons';
import { Icon, NavLink } from '../../../../components/Basic/Elements';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { TextGrey, Tooltip } from '../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import PostingStatusWrap from '../../../../components/Shipments/WrapStyle/PostingStatus';
import { MAP_SKLAD_SHORT, TO_POSING, TO_SHIPMENT, TYPE_BUTTONS } from '../../../../constans';
import { formFullDate, getDateMonth } from '../../../../utils';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';


const PostingLine = ({
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  isOwner = false,
  isAdmin = false,
  postingsPrint = {},
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };


  const scan_time_first = order.scan_time?.['pick'] ? formFullDate(order.scan_time?.['pick']) : null;
  const scan_time_order = order.scan_time?.packager ? formFullDate(order.scan_time?.packager) : null;

  return (
    <TableLine key={order.number}>
      <TableCell width={WIDTH_POSTING[8]} minWidth={WIDTH_POSTING[8]} center={true}>
        <Button
          disabled={order.status !== 'Ожидает отгрузки' || order.is_printed || !order.is_sticker_load}
          type={TYPE_BUTTONS.WHITE} className={styles.white_button} onClick={() => printSticker(order)}>
          <Icon src={barcode_image} width="35px" />
        </Button>
        <CheckButton
          checked={order.is_printed}
          small
          style={{ marginLeft: '10px' }}
          disabled={order.status !== 'Ожидает отгрузки' || order.is_printed || !order.is_sticker_load}
          onSelect={() => changePrintStatus([order.posting_number], !order.is_printed)}
        />
      </TableCell>
      <TableCell width={WIDTH_POSTING[0]}>
        {isAdmin ? (
          <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
            {order.posting_number}
          </Link>
        ) : (
          <>{order.posting_number} </>
        )}
        {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
        <Row style={{ width: '100%' }}>
          {order.market === 'wb' && <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>}
          {order.market === 'yandex' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'ozon' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'megamarket' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
          )}
        </Row>
      </TableCell>
      <TableCell width={WIDTH_POSTING[12]} center>
        <NavLink
          state={{ posting_number: order.posting_number }}
          to={TO_SHIPMENT(order.shipment_id)}
          // target={'_blank'}
          className={styles.scan_time}
          style={{ fontSize: '18px' }}
        >
          {getDateMonth(order.dates.shipment_date)}
        </NavLink>
      </TableCell>
      <TableCell width={WIDTH_POSTING[1]}>
        <Column>
          {order.products.map((p, k) => {
            const data = map[p.offer_id] || {};
            const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
            return (
              <div key={k} className={styles.div_line_images}>
                <div className={styles.wrapper}>
                  <img
                    onClick={() => openImageViewer(img)}
                    className={styles.preview}
                    src={img.length > 0 ? img[0] : undefined}
                  />
                </div>
                <Column>
                  <div className={styles.name}>
                    {`${p.ordered_quantity} x ${p.name}  `}
                    <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                      {p.offer_id}
                    </div>
                  </div>
                </Column>
              </div>
            );
          })}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[8]} center={true}>
        <Column>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <Row key={`${order.posting_number}-${p.offer_id}-19`} style={{ fontSize: '27px', 'fontWeight': 600 }} className={styles.div_line} center={true}>
              {p.common_quantity}
            </Row>
          ))}
        </Column>
      </TableCell>

      {/* <TableCell width={WIDTH_POSTING[8]} center={true}>
            <Column center={true}>
              {order.products.map((p, k) => (
                <Row key={`${order.posting_number}-${p.offer_id}-2`} className={styles.div_line}>
                  <RealQuantityInput
                    product={p}
                    onChangeProduct={(v) => onChangeProduct(order.posting_number, p._id, 'real_quantity', v)}
                  />
                </Row>
              ))}
            </Column>
          </TableCell> */}
      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <Column>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <Row key={`${order.posting_number}-${p.offer_id}-19`} className={styles.div_line} center={true}>
              {(p['diff'].comment || '').length > 0 ? (
                <>
                  <Tooltip text={p['diff'].comment}>
                    {p.diff.status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`} *
                  </Tooltip>
                </>
              ) : (
                <>
                  {p['diff'].status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}
                </>
              )}
            </Row>
          ))}
        </Column>
      </TableCell>

      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <PostingStatusWrap order={order} />
      </TableCell>
      <TableCell width={WIDTH_POSTING[6]} center>
        <Column style={{ alignItems: 'center' }}>
          <div>{MAP_SKLAD_SHORT[order.sklad]}</div>
          <div style={{ fontSize: '13px', color: '#0000007a', lineHeight: 1, marginTop: '5px' }}>{order.way?.from}</div>
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[12]} center>
        <Column style={{ alignItems: 'center' }}>
          <div>{order.sale_schema}</div>
          <div style={{ marginTop: '5px' }}>{order.supply_id}</div>
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center>
        <div>
          <div className={styles.user_name} style={{ fontWeight: 500 }}>
            {`${order.scan_user?.packager || ''}`}
          </div>
          <div className={styles.scan_time}> {scan_time_order}</div>
        </div>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center>
        <div>
          <div className={styles.user_name} style={{ fontWeight: 500 }}>
            {`${order.scan_user?.['pick'] || ''}`}
          </div>
          <div className={styles.scan_time}>{scan_time_first}</div>
        </div>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]}>
        <Column style={{ alignItems: 'center' }}>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line}>
              <ProviderList selectProviderId={p.provider_id} disabled={true} />
            </div>
          ))}
        </Column>
      </TableCell>

      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </TableLine>
  );
};

export default PostingLine;
